
/* Single image */
import img1 from '../images/service/img-1.jpg'
import img2 from '../images/service/img-2.png'
import img3 from '../images/service/img-3.jpg'
import img4 from '../images/service/img-4.jpg'
import img5 from '../images/service/img-5.jpg'
import img6 from '../images/service/img-6.jpg'





import Simg1 from '../images/service-single/img-1.jpg'
import Simg2 from '../images/service-single/img-2.jpg'
import Simg3 from '../images/service-single/img-3.jpg'
import Simg4 from '../images/service-single/img-4.jpg'
import Simg5 from '../images/service-single/img-5.jpg'
import Simg6 from '../images/service-single/img-7.jpg'


const Services = [
    {
        id: 1,
        image: img1,
        simag: Simg1,
        subtitle: 'Transport',
        title: 'Хранилище',
        description: 'Мы предоставляем современные складские помещения для хранения ваших товаров. Наши склады оснащены передовыми системами безопасности и климат-контроля, что гарантирует сохранность вашего имущества в любых условиях. Мы предлагаем гибкие условия аренды и широкий спектр дополнительных услуг, таких как управление запасами, маркировка и комплектация заказов. Наши специалисты всегда готовы помочь вам с выбором оптимального решения для вашего бизнеса. ',
        slug: 'Air-Transport'
    },
    {
        id: 2,
        image: img2,
        simag: Simg2,
        subtitle: 'Transport',
        title: 'Логистика',
        description: 'Наша компания предлагает комплексные логистические решения, которые позволяют оптимизировать цепочки поставок и обеспечить своевременную доставку грузов. Мы разрабатываем индивидуальные логистические стратегии, учитывая все особенности вашего бизнеса, чтобы вы могли сосредоточиться на развитии, а не на транспортных проблемах. Наши специалисты используют современные технологии для отслеживания и управления грузопотоками, обеспечивая высокий уровень сервиса и минимизацию затрат. ',
        slug: 'Ocean-Transport'
    },
    {
        id: 3,
        image: img3,
        simag: Simg3,
        subtitle: 'Transport',
        title: 'Груз',
        description: 'Наша компания специализируется на перевозке грузов любых видов и размеров. Мы предлагаем транспортировку с учетом всех требований и особенностей вашего груза, будь то негабаритные, опасные или температурно-зависимые товары. Мы обеспечиваем надежную упаковку и страхование груза, а также оперативное оформление всех необходимых документов. Наши услуги позволяют вам быть уверенными в сохранности и своевременной доставке вашего груза в любую точку мира. ',
        slug: 'Road-Transport'
    },
    {
        id: 4,
        image: img4,
        simag: Simg4,
        subtitle: 'Transport',
        title: 'Автоперевозки',
        description: 'Мы предоставляем услуги автоперевозок по всей территории страны и за её пределами. Наш автопарк состоит из современных транспортных средств, соответствующих всем требованиям безопасности и экологическим стандартам. Мы гарантируем своевременную доставку грузов, независимо от их объема и назначения. Наши водители имеют богатый опыт и высокую квалификацию, что позволяет нам осуществлять перевозки на высшем уровне. ',
        slug: 'Road-Transport2'
    },
    {
        id: 5,
        image: img5,
        simag: Simg5,
        subtitle: 'Transport',
        title: 'Упаковка',
        description: 'Мы предлагаем профессиональные услуги по упаковке грузов, обеспечивая их сохранность на протяжении всего пути следования. Наша компания использует только высококачественные материалы и современные технологии упаковки, что позволяет защитить товары от любых повреждений. Мы учитываем все особенности вашего груза и подбираем оптимальный способ упаковки, будь то коробки, паллеты или специализированная тара. Доверив нам упаковку, вы можете быть уверены в целостности вашего груза. ',
        slug: 'Ocean-Transport2'
    },

    {
        id: 6,
        image: img6,
        simag: Simg6,
        subtitle: 'Transport',
        title: 'Складирование',
        description: 'Наши складские услуги включают не только хранение, но и полный спектр логистических операций, таких как сортировка, комплектация и доставка товаров. Мы располагаем современными складами с различными условиями хранения, что позволяет нам работать с широким ассортиментом товаров. Мы предлагаем индивидуальные решения для каждого клиента, обеспечивая максимальную эффективность и минимальные сроки выполнения заказов. С нами ваше имущество всегда в надежных руках. ',
        slug: 'Train-Transport3'
    },

];
export default Services;